import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "export-content__integration-button-text" }
const _hoisted_5 = { class: "export-content__integration-button-title" }
const _hoisted_6 = { class: "export-content__integration-button-description" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'IntegrationButton',
  props: {
    name: {},
    description: {},
    imageUrl: {},
    darkImageUrl: {},
    isSelected: { type: Boolean, default: false },
    isSelectable: { type: Boolean, default: true },
    isEnabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const parsedState = computed(() => {
  if (!props.isSelectable) {
    return 'Coming Soon'
  }
  if (props.isEnabled) {
    return 'Connected'
  }
  return ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: !__props.isSelectable,
    class: _normalizeClass(["export-content__integration-button", {
      ['export-content__integration-button-' + __props.name]: true,
      'export-content__integration-button-selected': __props.isSelected,
    }])
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("img", {
        class: "export-content__integration-button-logo",
        src: __props.imageUrl
      }, null, 8, _hoisted_2),
      _createElementVNode("img", {
        class: "export-content__integration-button-logo-dark",
        src: __props.darkImageUrl
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.name), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(__props.description), 1)
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["export-content__integration-state-label", {
        'export-content__integration-label-coming-soon': !__props.isSelectable,
        'export-content__integration-label-connected': __props.isEnabled,
      }])
    }, _toDisplayString(parsedState.value), 3)
  ], 10, _hoisted_1))
}
}

})